<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <b-card>
          <div slot="header">
            <div>
              <b-row>
                <b-col sm="3">
                  <i class="fa fa-bars"></i> {{ $t('str.search-history-user-list') }}
                </b-col>
                <b-col sm="6">
                </b-col>
                <b-col sm="3">
                  <div style="display:inline-block; float:right;">
                    
                  </div>
                </b-col>
              </b-row>
            </div>
            <div>
              <b-row style="margin-top:10px;">
                <b-col sm="12">
                  <b-row>
                    <b-col sm="6">Keyword</b-col>
                    <b-col sm="3">Country</b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="6">
                      <b-form-input id="keyword" class="form-control" type="text" name="keyword"
                        :placeholder="$t('str.search')"
                        v-model="keyword"
                        @keyup.enter="getAllUser()"></b-form-input>
                    </b-col>
                    <b-col sm="3">
                      <b-form-select id="country" name="country" :plain="true" v-model="country_code" style="height:100%;">
                        <option value="">All</option>
                        <option v-for="(c, index) in countryListSelect" :value="c.value" :key="index">{{c.text}}</option>
                      </b-form-select>
                    </b-col>
                    <b-col sm="3">
                      <b-button type="button" variant="secondary" @click="resetFilter()" style="float:right;">{{ $t('str.reset-filter') }}</b-button>&nbsp;
                      <b-button type="submit" variant="primary" @click="getAllUser()" style="float:right;">{{ $t('str.search') }}</b-button>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </div>
          </div>
          <p :class="{'text-center':true, 'd-none':items.length}" class="">{{ $t('str.no-data') }}</p>
          <b-table :class="{'d-none':!items.length}" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage">
            <template slot="action" slot-scope="data">
              <router-link :to="'/search-history/user/'+data.item.id">
                <b-button variant="secondary" size="sm">
                  <i class="fa fa-eye"></i>&nbsp;{{ $t('str.view') }}
                </b-button>
              </router-link>
            </template>
          </b-table>
          <nav :class="{'d-none':!items.length}">
            <paging :current-page="currentPage"
              :total-pages="totalPage"
              @page-changed="pageOneChanged"
              prev-text="Prev" next-text="Next"/>
          </nav>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'

import Pagination from '@/views/component/Pagination'
import Buttons from '@/views/component/Buttons'

export default {
  name:'SearchHistoryUserList',
  components:{
    'paging':Pagination,
    'buttons': Buttons
  },
  props:{
    hover:{type:Boolean, default:false},
    striped:{type:Boolean, default:false},
    bordered:{type:Boolean, default:false},
    small:{type:Boolean, default:false},
    fixed:{type:Boolean, default:false}
  },
  data() {
    return {
      items:[],
      countryListSelect:[],
      fields:[
        {key:'no', label:'No.'},
        {key:'user_name', label:'User', sortable:true},
        {key:'email', sortable:true},
        {key:'country_name', label:'Country', sortable:true},
        {key:'action'}
      ],
      keyword:'',
      country_code:'',
			submittedExport:false,
      currentPage:1,
      // perPage:0,
      totalPage:0,
      notificationSystem:this.$helper.notifCfg()
    }
  },
  methods:{
    async getAllCountry() {
      this.$auth.checkSession()
  		try {
	  		let getData = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/User/Country`, {
					headers:{ 'Authorization':`Bearer ${this.$auth.session.get().passport}` }
				})
				let cData = getData.data.data

				for(var i=0; i<cData.length; i++) {
          this.countryListSelect.push({'value':cData[i].code, 'text':cData[i].name})
        }
	  	} catch(e) {
	  		console.log(e.response)
	  	}
		},
    async getAllUser(page) {
      this.$auth.checkSession()
      var trail = `?history=1&limit=${this.$helper.envi.VUE_APP_PAGING_LIMIT}`
      if(page) trail = `${trail}&page=${page}`
      if(this.keyword != '') trail = `${trail}&keyword=${this.keyword}`
      if(this.country_code != '') trail = `${trail}&country_code=${this.country_code}`

      try {
        var getData = await axios.get(`${this.$helper.envi.VUE_APP_API_URL}/User${trail}`, {
          headers:{ 'Authorization':`Bearer ${this.$auth.session.get().passport}` }
        })

        this.items = getData.data.data
        if(this.items[0].id == 0)
          this.items[0].country_name = 'Guest'

        this.currentPage = getData.data.meta.page
        this.totalPage = getData.data.meta.pageCount
      } catch(e) {
        console.log(e.response)
					if(e.response) {
						this.$router.push('/pages/404')
					}
      }
    },
    async exportFile() {
			this.exportFileSuccess = ''
			this.exportFileError = ''
			this.$auth.checkSession()
			
			let url = `${this.$helper.envi.VUE_APP_API_URL}/Export/SearchHistoryUser`
			
			try {
				this.submittedExport = true
				let file = await axios.get(url, {
					headers:{'Authorization':`Bearer ${this.$auth.session.get().passport}`}
				})
				if(file.data){
					window.open(this.$helper.envi.VUE_APP_API_URL+'/'+file.data)
				}

        let delUrl = this.$helper.envi.VUE_APP_API_URL+'/Export/DownloadFile/User'
				let delAuth = this.$auth.session.get().passport
				let timer = setInterval(async function(){
					if(open.closed){
						clearInterval(timer)
						await axios.get(delUrl, {
							headers:{'Authorization':`Bearer ${delAuth}`}
						})
					}
				}, 1000)
			} catch(e) {
				console.log(e)
			}
			this.submittedExport = false
    },
    resetFilter() {
      this.keyword = ''
      this.country_code = ''
      this.getAllCountry()
      this.getAllUser()
    },
    pageOneChanged (pageNum) {
      this.currentPage = pageNum
      this.getAllUser(pageNum)
    }
  },
  created() {
    this.getAllCountry()
    this.getAllUser()
  }
}
</script>